// extracted by mini-css-extract-plugin
export default {"cart__product":"CartProductItem_cart__product__c06ke","cart__delete":"CartProductItem_cart__delete__GX9xL"};